import type { FileImageUsage } from '@vedalib/editor/lib/files'
import { FileUsageTypeEnum } from '@vedalib/editor/lib/files'
import cn from 'classnames'
import { motion } from 'framer-motion'

import { useElementRootStyles } from 'components/Editor/EditorElements/hooks/useElementRootStyles'
import { PreviewMode } from 'services/Store/Project/enums'
import { useUrlByUsage } from 'utils/files'

import { useSimulatorContext } from '../SimulatorContext'
import mock from '../assets/imageDemo.svg'
import * as s from './Item.module.scss'

interface IItem {
  image: Omit<FileImageUsage, 'type'> | null
  overlay: string | null
  showAnimation?: boolean
}

const Item = ({ image, overlay, showAnimation }: IItem) => {
  const styles = useSimulatorContext((c) => c.styles)
  const previewMode = useSimulatorContext((c) => c.mode).previewMode
  const url = useUrlByUsage(image, FileUsageTypeEnum.image)
  const imageStyles = useElementRootStyles(styles.image)
  const isPdf = previewMode === PreviewMode.pdf
  // todo: use ResponsiveImage(CourseImage) instead of img tag
  const Image = (
    <>
      <img
        alt={image?.accessibility || ''}
        className={cn(s.img, { [s.empty]: !url })}
        draggable='false'
        src={url || mock}
        style={{ objectFit: url ? image?.objectFit : 'none' }}
      />
      <div className={s.mask} style={{ backgroundColor: overlay || undefined }} />
    </>
  )

  return showAnimation ? (
    <motion.div
      animate={{ opacity: 1, scale: 1 }}
      className={s.root}
      exit={{ opacity: 0, scale: 1.05 }}
      initial={{ opacity: 0, scale: 0.95 }}
      style={{ ...imageStyles, ...styles.effects }}
      transition={{ duration: 0.3, ease: 'easeInOut' }}
    >
      {Image}
    </motion.div>
  ) : (
    <div className={cn(s.root, { [s.pdf]: isPdf })} style={{ ...imageStyles, ...styles.effects }}>
      {Image}
    </div>
  )
}

export default Item
